import { CreatePostFormV2 } from "@/components/CreatePostFormV2";
import { useLocalSearchParams } from "expo-router";

export default function PostPage() {
  const { groupId, targetName } = useLocalSearchParams<{
    groupId?: string;
    targetName?: string;
  }>();

  return <CreatePostFormV2 groupId={groupId} targetName={targetName} />;
}
